const enBettingRulesURL = 'http://888-external-en.custhelp.com/app/answers/detail/a_id/5743/prod/?NativeExternal=true';
const esBettingRulesURL = 'http://888-external-espana.custhelp.com/app/answers/detail/a_id/11236/p/?NativeExternal=true';
const dkBettingRulesURL = 'http://888-external-dk.custhelp.com/app/answers/detail/a_id/11616/p/?NativeExternal=true';
const comDeBettingRulesURL = 'http://888-external-de.custhelp.com/app/answers/detail/a_id/5760/prod/?NativeExternal=true';
const comEsBettingRulesURL = 'http://888-external-es.custhelp.com/app/answers/detail/a_id/5773/prod/?NativeExternal=true';
const comRuBettingRulesURL = 'http://888-external-ru.custhelp.com/app/answers/detail/a_id/10968/prod/?NativeExternal=true';
const itBettingRulesURL = 'https://www.888sport.it/come-scommettere/regole-generali?NativeExternal=true';
const shBettingRulesURL = 'https://sh.888.de/how-to-bet/betting-rules/';
const roBettingRulesURL = 'https://www.888sport.ro/how-to-bet/betting-rules/general/?NativeExternal=true';
const comUserAgreementURL = 'http://www.888.com/security-and-privacy/user-agreement.htm?NativeExternal=true';
const shUserAgreementURL = 'https://sh.888.de/security-and-privacy/user-agreement/';
const deBettingRulesURL = 'https://www.888sport.de/erste-schritte/sportwetten-regeln/';
const deUserAgreementURL = 'https://www.888sport.de/sicherheit-datenschutz/nutzungsvereinbarung/';

function getBettingRulesTextByLang(langISo2) {
  const texts = {
    en: '*Maximum payout limits apply',
    es: '*Sujeto a límites máximos de pago',
    de: '*Maximale Auszahlungslimits sind gültig',
    fr: '*Les limites de gain maximum s\'appliquent',
    sv: '*Maximala utbetalningsgränser gäller',
    pt: '*Aplicam-se os limites máximos de pagamento',
    ru: '*Действуют максимальные лимиты выплат',
    no: '*Maksimale utbetalingsgrenser gjelder',
    fi: '*Enimmäisvoittorajoituksia sovelletaan',
    it: '*Si applicano i limiti relativi alla vincita massima',
    da: '*Regler for maksimal udbetaling gælder',
    ro: '*Se aplica limite maxime de plata'
  };

  return texts[langISo2] || texts['en'];
}

function getUserAgreementTextByLang(langISo2) {
  const texts = {
    en: 'Please note, that if successful, we will retain 5% of the winnings from your bet.',
    es: 'Ten en cuenta que retendremos el 5% de los beneficios de tu apuesta si consigues ganar.',
    de: 'Bitte beachten Sie, dass im Falle eines Gewinns, 5% des Gewinns von Ihrer Wette einbehalten wird.',
    fr: 'Veuillez noter que, si ce dernier est gagnant, nous conserverons 5 % des gains de votre pari.',
    sv: 'Observera att om du klarar det kommer vi att behålla 5 % av vinsten från din satsning.',
    pt: 'Observe que, em caso de êxito, nós reteremos 5% dos ganhos da sua aposta.',
    ru: 'Обратите внимание: если ваша ставка сыграет, мы удержим с нее 5% выигрыша.',
    no: 'Vær oppmerksom på at vi beholder 5 % av gevinsten hvis du lykkes.',
    fi: 'Huomaa, että onnistumisen yhteydessä pidätämme 5 prosenttia panoksesi voitoista.',
    it: 'Si applicano i limiti relativi alla vincita massima',
    da: 'Regler for maksimal udbetaling gælder'
  };

  return texts[langISo2] || texts['en'];
}

function getBettingRulesLinkByLang(brand, langIso2) {
  switch (langIso2) {
    case 'es':
      return comEsBettingRulesURL;
    case 'de':
      return comDeBettingRulesURL;
    case 'ru':
      return comRuBettingRulesURL;
    default:
      return enBettingRulesURL;
  }
}

const commonLinkSettings = {
  external: false,
  imageHref: ''
};

export function getKambiLinksConfig(brand, langIso2) {
  return {
    0: {
      default: {
        betSlipLinks: [
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      },
      DEU: {
        betSlipLinks: [
          {
            url: comUserAgreementURL,
            label: getUserAgreementTextByLang(langIso2),
            sortOrder: 1,
            ...commonLinkSettings
          },
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            label: getBettingRulesTextByLang(langIso2),
            sortOrder: 2,
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: comUserAgreementURL,
            label: getUserAgreementTextByLang(langIso2),
            sortOrder: 1,
            ...commonLinkSettings
          },
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            label: getBettingRulesTextByLang(langIso2),
            sortOrder: 2,
            ...commonLinkSettings
          }
        ]
      }
    },
    1: {
      default: {
        betSlipLinks: [
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      },
      DEU: {
        betSlipLinks: [
          {
            url: comUserAgreementURL,
            label: getUserAgreementTextByLang(langIso2),
            sortOrder: 1,
            ...commonLinkSettings
          },
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            label: getBettingRulesTextByLang(langIso2),
            sortOrder: 2,
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: comUserAgreementURL,
            label: getUserAgreementTextByLang(langIso2),
            sortOrder: 1,
            ...commonLinkSettings
          },
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            label: getBettingRulesTextByLang(langIso2),
            sortOrder: 2,
            ...commonLinkSettings
          }
        ]
      }
    },
    8: {
      default: {
        betSlipLinks: [
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      },
      DEU: {
        betSlipLinks: [
          {
            url: comUserAgreementURL,
            label: getUserAgreementTextByLang(langIso2),
            sortOrder: 1,
            ...commonLinkSettings
          },
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            label: getBettingRulesTextByLang(langIso2),
            sortOrder: 2,
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: comUserAgreementURL,
            label: getUserAgreementTextByLang(langIso2),
            sortOrder: 1,
            ...commonLinkSettings
          },
          {
            url: getBettingRulesLinkByLang(brand, langIso2),
            label: getBettingRulesTextByLang(langIso2),
            sortOrder: 2,
            ...commonLinkSettings
          }
        ]
      }
    },
    58: {
      default: {
        betSlipLinks: [
          {
            url: esBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: esBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      }
    },
    31: {
      default: {
        betSlipLinks: [
          {
            url: itBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: itBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      }
    },
    75: {
      default: {
        betSlipLinks: [
          {
            url: dkBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: dkBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      }
    },
    76: {
      default: {
        betSlipLinks: [
          {
            url: roBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: roBettingRulesURL,
            sortOrder: 1,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      }
    },
    83: {
      default: {
        betSlipLinks: [
          {
            url: shUserAgreementURL,
            sortOrder: 1,
            label: getUserAgreementTextByLang(langIso2),
            ...commonLinkSettings
          },
          {
            url: shBettingRulesURL,
            sortOrder: 2,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: shUserAgreementURL,
            sortOrder: 1,
            label: getUserAgreementTextByLang(langIso2),
            ...commonLinkSettings
          },
          {
            url: shBettingRulesURL,
            sortOrder: 2,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      }
    },
    84: {
      default: {
        betSlipLinks: [
          {
            url: deUserAgreementURL,
            sortOrder: 1,
            label: getUserAgreementTextByLang(langIso2),
            ...commonLinkSettings
          },
          {
            url: deBettingRulesURL,
            sortOrder: 2,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ],
        betHistoryLinks: [
          {
            url: deUserAgreementURL,
            sortOrder: 1,
            label: getUserAgreementTextByLang(langIso2),
            ...commonLinkSettings
          },
          {
            url: deBettingRulesURL,
            sortOrder: 2,
            label: getBettingRulesTextByLang(langIso2),
            ...commonLinkSettings
          }
        ]
      }
    }
  };
}
